import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSystemLogin } from '../contexts/SystemLoginContext';
import { createSystemLoginApiClient } from '../utils/systemLoginApi';

interface HeaderProps {
  className?: string;
}

const Header: React.FC<HeaderProps> = ({ className = '' }) => {
  const navigate = useNavigate();
  const systemLogin = useSystemLogin();
  const apiClient = createSystemLoginApiClient(systemLogin);

  const handleLogin = () => {
    navigate('/login');
  };

  const handleLogout = () => {
    const success = apiClient.logout();
    if (success) {
      console.log('已成功注销');
      navigate('/');
    } else {
      console.error('注销失败');
    }
  };

  const handleRecharge = () => {
    navigate('/recharge');
  };

  const headerStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1rem 1rem',
    color: '#ffffff',
  };

  const logoStyle: React.CSSProperties = {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#ffffff',
    textDecoration: 'none',
    cursor: 'pointer',
  };

  const userSectionStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  };

  const statusStyle: React.CSSProperties = {
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    fontSize: '0.9rem',
    backgroundColor: systemLogin.isLoggedIn ? '#22c55e' : '#ef4444',
    color: '#ffffff',
    width: '100px',
    textAlign: 'center',
  };

  const buttonStyle: React.CSSProperties = {
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    border: '1px solid #444444',
    backgroundColor: 'transparent',
    color: '#ffffff',
    cursor: 'pointer',
    fontSize: '0.9rem',
    transition: 'all 0.3s ease',
    width: '100px',
    textAlign: 'center',
  };

  const retryInfoStyle: React.CSSProperties = {
    fontSize: '0.8rem',
    color: '#cccccc',
  };

  return (
    <header className={className} style={headerStyle}>
      <div style={logoStyle} onClick={() => navigate('/')}>
      </div>
      
      <div style={userSectionStyle}>        
        {/* 重试次数显示（如果有的话） */}
        {systemLogin.retryLoginTimes > 0 && (
          <div style={retryInfoStyle}>
            重试次数: {systemLogin.retryLoginTimes}
          </div>
        )}
        
        {/* 加载状态显示 */}
        {systemLogin.isLoading && (
          <div style={retryInfoStyle}>
            登录中...
          </div>
        )}
        
        {/* 登录成功后显示的功能按钮 */}
        {systemLogin.isLoggedIn && (
          <>
            <button 
              style={buttonStyle} 
              onClick={handleRecharge}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#333333';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
              }}
            >
              充值
            </button>
          </>
        )}
        
        {/* 登录/注销按钮 */}
        {systemLogin.isLoggedIn ? (
          <button 
            style={buttonStyle} 
            onClick={handleLogout}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#333333';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            注销
          </button>
        ) : (
          <button 
            style={buttonStyle} 
            onClick={handleLogin}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#333333';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            登录
          </button>
        )}
      </div>
    </header>
  );
};

export default Header; 